import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from 'redux-persist';
import {
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import rootReducer from "./rootReducer";
import storage from "./storage";

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['Layout', 'Admin', 'Builder', 'Inspector', 'User'], // ✅ Fixed: Match exact slice names
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({ 
    reducer: persistedReducer, 
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        },
      }),
    devTools: true 
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;